import styled from 'styled-components';
import { TokenName } from '@mewssystems/design-tokens';
import { getTextTokenPreset, getToken } from '@optimus-web/common';

export const TableEmptyStateContainer = styled.div`
    padding: ${getToken(TokenName.SPACING_900)}px ${getToken(TokenName.SPACING_0)};
`;

export const TableEmptyStatePrimaryText = styled.div`
    ${getTextTokenPreset('BODY_M_STRONG')};
    color: ${getToken(TokenName.TEXT_STATIC_PRIMARY)};
`;

export const TableEmptyStateSecondaryText = styled.div`
    ${getTextTokenPreset('BODY_M_STRONG')};
    color: ${getToken(TokenName.TEXT_STATIC_SECONDARY)};
`;
